<script setup lang="ts">
/** Un icono por tipo de corte. Trazo, no emoji: escala y se recolorea. */
defineProps<{ name: string, size?: number }>()
</script>

<template>
  <svg :width="size || 26" :height="size || 26" viewBox="0 0 24 24" fill="none"
       stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <template v-if="name === 'degrade'">
      <path d="M4 18h16" /><path d="M6 14h12" opacity=".75" /><path d="M8 10h8" opacity=".5" /><path d="M10 6h4" opacity=".28" />
    </template>
    <template v-else-if="name === 'barbe'">
      <path d="M6 6v4a6 6 0 0 0 12 0V6" /><path d="M9 13.5c1 1 4 1 6 0" /><path d="M6 6h12" />
    </template>
    <template v-else-if="name === 'coupe_barbe'">
      <circle cx="9" cy="8" r="3.2" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><path d="M16 7h5M16 11h5M16 15h5" opacity=".55" />
    </template>
    <template v-else-if="name === 'rasage'">
      <path d="M3 20 14 9" /><path d="m13 4 7 7-3.5 3.5-7-7z" /><path d="M3 20h4" />
    </template>
    <template v-else-if="name === 'enfant'">
      <circle cx="12" cy="9" r="4" /><path d="M5 21a7 7 0 0 1 14 0" /><path d="M9 6c1.5-1.5 4.5-1.5 6 0" />
    </template>
    <template v-else-if="name === 'sourcils'">
      <path d="M3 12c2.5-3 6.5-3 9 0" /><path d="M12 12c2.5-3 6.5-3 9 0" opacity=".55" />
    </template>
    <template v-else-if="name === 'coloration'">
      <path d="M12 3s6 6.5 6 10a6 6 0 0 1-12 0c0-3.5 6-10 6-10z" /><path d="M9 14a3 3 0 0 0 3 3" opacity=".5" />
    </template>
    <!-- corte, y cualquier otro: tijeras -->
    <template v-else>
      <circle cx="6" cy="6" r="2.6" /><circle cx="6" cy="18" r="2.6" />
      <path d="M8.2 7.6 20 18M8.2 16.4 20 6" />
    </template>
  </svg>
</template>
